import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { SpinnerService, SpinnerState } from "@app/core/spinner/spinner.service";
import { Subscription } from "rxjs";

export enum SpinnerTypes {
	CHASING_DOTS,
	CIRCLE,
	CUBE_GRID,
	DOUBLE_BOUNCE,
	FADING_CIRCLE,
	FOLDING_CUBE,
	PULSE,
	ROTATING_PLANE,
	THREE_BOUNCE,
	WANDERING_CUBES,
	WAVE,
	WORD_PRESS
}

@Component({
	selector: "app-spinner",
	templateUrl: "./spinner.component.html",
	styleUrl: "./spinner.component.css",
	standalone: false
})
export class SpinnerComponent implements OnDestroy, OnInit {
	@Input() spinnerType: number;
	@Input() random: boolean;
	innerSpinnerType: number;
	baseClass: string;
	childClass: string;
	items: number[];
	visible: boolean;
	private spinnerStateChanged: Subscription;

	constructor(private spinnerService: SpinnerService) {
		if (!this.visible) {
			this.visible = false;
		}
	}

	ngOnDestroy(): any {
		this.spinnerStateChanged.unsubscribe();
	}

	ngOnInit() {
		if (this.spinnerType === undefined || this.spinnerService === null) {
			this.innerSpinnerType = Math.round(Math.random() * 10);
		} else {
			this.innerSpinnerType = this.spinnerType;
		}
		if (this.random === undefined || this.random === null) {
			this.random = true;
		}
		this.initSpinner();
		this.spinnerStateChanged = this.spinnerService.spinnerState
			.subscribe((state: SpinnerState) => {
				this.visible = state.show.valueOf();
				if (this.random) {
					this.innerSpinnerType = Math.round(Math.random() * 10);
					this.initSpinner();
				}
			});
	}

	initSpinner(): void {
		/* switch (this.innerSpinnerType) {
			case SpinnerTypes.CHASING_DOTS:
				this.baseClass = 'chasing-dots-spinner';
				this.childClass = 'dot';
				this.items = new Array(2);
				break;
			case SpinnerTypes.CIRCLE:
				this.baseClass = 'circle-spinner';
				this.childClass = 'circle';
				this.items = new Array(12);
				break;
			case SpinnerTypes.CUBE_GRID:
				this.baseClass = 'cube-grid-spinner';
				this.childClass = 'cube';
				this.items = new Array(9);
				break;
			case SpinnerTypes.DOUBLE_BOUNCE:
				this.baseClass = 'double-bounce-spinner';
				this.childClass = 'double-bounce';
				this.items = new Array(2);
				break;
			case SpinnerTypes.FADING_CIRCLE:
				this.baseClass = 'fading-circle-spinner';
				this.childClass = 'circle';
				this.items = new Array(12);
				break;
			case SpinnerTypes.FOLDING_CUBE:
				this.baseClass = 'folding-cube-spinner';
				this.childClass = 'cube';
				this.items = new Array(4);
				break;
			case SpinnerTypes.PULSE:
				this.baseClass = 'pulse-spinner';
				this.childClass = '';
				this.items = new Array(0);
				break;
			case SpinnerTypes.ROTATING_PLANE:
				this.baseClass = 'rotating-plane-spinner';
				this.childClass = '';
				this.items = new Array(0);
				break;
			case SpinnerTypes.THREE_BOUNCE:
				this.baseClass = 'three-bounce-spinner';
				this.childClass = 'bounce';
				this.items = new Array(3);
				break;
			case SpinnerTypes.WANDERING_CUBES:
				this.baseClass = 'wandering-cubes-spinner';
				this.childClass = 'cube';
				this.items = new Array(2);
				break;
			case SpinnerTypes.WAVE:
				this.baseClass = 'wave-spinner';
				this.childClass = 'rect';
				this.items = new Array(5);
				break;
			case SpinnerTypes.WORD_PRESS:
				this.baseClass = 'word-press-spinner';
				this.childClass = '';
				this.items = new Array(0);
				break;
			default: */
		this.baseClass = "three-bounce-spinner";
		this.childClass = "bounce";
		this.items = new Array(3);
		// }
	}
}